import React from 'react';
import { connect } from 'react-redux'
import {LoadingComponent} from '../../utils/ui'
import {getNameByLabel, getTeamworks} from '../../utils/emdUtil'
import { EMDActions } from '../../redux';


/**
 * Формирует PlantUML скрипт для отображения UML Диаграммы
 */
const makeClass = element => {
    return "class \""+element.name+"\" as C"+element.key+" <<Object>>{\n"
        +element.item.iri+"\n"
        +"==\n"
        +"}\n";
}
const makeGeneral = element => {
    return "C"+element.key+" --|> C"+element.parent.key+"\n";
}
const makeScript = (element) => {
     let script = makeClass(element);
     if (element.parent){
        script = script+makeClass(element.parent);
        script = script+makeGeneral(element);
     }
     script = script+makeTeamworks(element);
     if (Array.isArray(element.children))
        element.children.map(sub => script = script+ makeClass(sub)+makeGeneral(sub));
     return script;
}
const makeTeamworks = element => {
    const teamworks = getTeamworks(element);
    if (Array.isArray(teamworks)&&teamworks.length>0){
        //Список задания определяем по виду связи
        const tasks = teamworks.filter (item => item&&item.annotations&&item.annotations.identifierToAnnotation&&item.annotations.identifierToAnnotation.task);
        //Список требований определяем по виду связи
        const requirements = teamworks.filter (item => item&&item.annotations&&item.annotations.identifierToAnnotation&&item.annotations.identifierToAnnotation.implementedBy);
        let script = "note left of C"+element.key+"\n";
        if (tasks.length>0){
            script = script +"<u>Задания</u>\n"
            tasks.map(task => script = script+ getNameByLabel(task.annotations)+"\n");
        }
        if (requirements.length>0){
            script = script +"<u>Требования</u>\n"
            requirements.map(requirement => script = script+ getNameByLabel(requirement.annotations)+"\n");
        }
        script =  script +"end note\n";
        return script; 
    }
    return "";
}
class UMLDiagramm extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            url: undefined,
            loading: false, 			//Флаг загрузки
        }
    }

    componentDidMount() {
        this.loadPlantUML()
    }

    componentWillReceiveProps(newProps) {
        this.setState({url: null});
    }

    loadPlantUML(){
        const selected = this.props.selected;
        const script = makeScript(selected);
        this.props.onLoadPlantUML(script).then(response =>{
            //console.log("executeGetPlantUML"); console.log(response);
            this.setState({url: response});
        });
    }

    render() {
        console.log(this);
        const selected = this.props.selected;
        const url = this.state.url;
        if (url==null) this.loadPlantUML();
        return (
            <div>
                {!url&& <LoadingComponent />}                
                {url&& (<a href={url} target="_blank"><img src={url} style={{maxWidth:"100%", height:"auto"}}/></a>)}                
                <div style={{display:"none"}}>{makeScript(selected)}</div>
            </div>
        );
    }
};

//Представление информации о диаграмме UML элемента EMD
export default connect(
  null,
  dispatch => ({
    onLoadPlantUML(script){
      return dispatch(EMDActions.getPluntumlURL(script));
    },      
  })
)(UMLDiagramm);